"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rowClickRenderFn = exports.rowLinkRenderFn = exports.headerRenderFn = exports.defaultRenderFn = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const CssReset_1 = require("../../CssReset");
const TableStyles_1 = require("../TableStyles");
const Tooltip_1 = require("../../Tooltip");
const Css_1 = require("../../../Css");
/** Renders our default cell element, i.e. if no row links and no custom renderCell are used. */
const defaultRenderFn = (as) => (key, css, content, row, rowStyle, classNames, onClick, tooltip) => {
    const Cell = as === "table" ? "td" : "div";
    return ((0, jsx_runtime_1.jsx)(Cell, { css: { ...css, ...(0, TableStyles_1.tableRowStyles)(as) }, className: classNames, onClick: onClick, children: (0, Tooltip_1.maybeTooltip)({ title: tooltip, placement: "top", children: content }) }, key));
};
exports.defaultRenderFn = defaultRenderFn;
/**
 * Sets up the `GridContext` so that header cells can access the current sort settings.
 * Used for the Header, Totals, and Expanded Header row's cells.
 * */
const headerRenderFn = (column, as, colSpan) => (key, css, content, row, rowStyle, classNames, onClick, tooltip) => {
    const Cell = as === "table" ? "th" : "div";
    return ((0, jsx_runtime_1.jsx)(Cell, { css: { ...css, ...(0, TableStyles_1.tableRowStyles)(as, column) }, className: classNames, ...(as === "table" && { colSpan }), children: (0, Tooltip_1.maybeTooltip)({ title: tooltip, placement: "top", children: content }) }, key));
};
exports.headerRenderFn = headerRenderFn;
/** Renders a cell element when a row link is in play. */
const rowLinkRenderFn = (as) => (key, css, content, row, rowStyle, classNames, onClick, tooltip) => {
    const to = rowStyle.rowLink(row);
    if (as === "table") {
        return ((0, jsx_runtime_1.jsx)("td", { css: { ...css, ...(0, TableStyles_1.tableRowStyles)(as) }, className: classNames, children: (0, Tooltip_1.maybeTooltip)({
                title: tooltip,
                placement: "top",
                children: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: to, css: Css_1.Css.noUnderline.color("unset").db.$, className: CssReset_1.navLink, children: content })),
            }) }, key));
    }
    return (0, Tooltip_1.maybeTooltip)({
        title: tooltip,
        placement: "top",
        children: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: to, css: { ...Css_1.Css.noUnderline.color("unset").$, ...css }, className: `${CssReset_1.navLink} ${classNames}`, children: content }, key)),
    });
};
exports.rowLinkRenderFn = rowLinkRenderFn;
/** Renders a cell that will fire the RowStyle.onClick. */
const rowClickRenderFn = (as, api) => (key, css, content, row, rowStyle, classNames, onClick, tooltip) => {
    const Cell = as === "table" ? "td" : "div";
    return ((0, jsx_runtime_1.jsx)(Cell, { ...{ key }, css: { ...css, ...(0, TableStyles_1.tableRowStyles)(as) }, className: classNames, onClick: (e) => {
            rowStyle.onClick(row, api);
            onClick && onClick();
        }, children: (0, Tooltip_1.maybeTooltip)({ title: tooltip, placement: "top", children: content }) }));
};
exports.rowClickRenderFn = rowClickRenderFn;
